import { render, staticRenderFns } from "./payConfirm.vue?vue&type=template&id=0fce3fc0&"
import script from "./payConfirm.vue?vue&type=script&lang=js&"
export * from "./payConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports